/**
 * @group Constants

@summary
<blockquote>Sentry-specific error codes for logging transport</blockquote>

@example
```typescript
import { SENTRY_ERROR_CODES } from '@shared/logger/sentry/constants';

return err({
  errorMessage: 'Failed to initialize',
  errorCode: SENTRY_ERROR_CODES.INIT_FAILED
});
```
 * @internal
 */
export const SENTRY_ERROR_CODES = {
  DSN_REQUIRED: 'SENTRY_DSN_REQUIRED',
  ENVIRONMENT_NOT_FOUND: 'ENVIRONMENT_NOT_FOUND',
  INIT_FAILED: 'SENTRY_INIT_FAILED',
  NOT_INITIALIZED: 'SENTRY_NOT_INITIALIZED',
  CAPTURE_ERROR: 'SENTRY_CAPTURE_ERROR',
  CLOSE_ERROR: 'SENTRY_CLOSE_ERROR',
  GLOBAL_HANDLERS_SENTRY_INIT_FAILED: 'GLOBAL_HANDLERS_SENTRY_INIT_FAILED',
  GLOBAL_HANDLERS_SETUP_FAILED: 'GLOBAL_HANDLERS_SETUP_FAILED',
} as const;

